
import {ref,computed} from 'vue'


export default function useTogglePassword(){

   const passwordFieldType = ref('password')

   const togglePasswordVisibility = () => {
      passwordFieldType.value = passwordFieldType.value === 'password' ? 'text' : 'password'
   }

   const passwordToggleicon = computed(() => {
      return passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
   })


   return {
      passwordFieldType,
      togglePasswordVisibility,
      passwordToggleicon
   }
  

  
}

export const _ = null
